import { createReducer } from '@reduxjs/toolkit';
import get from 'lodash/get';

import { isMfaChallengeResponse } from 'utils/mfa';
import { NOT_FOUND_PATH, ROOT_PATH } from 'constants/route-paths';
import {
  ActionClearType,
  ActionFailureType,
  ActionSuccessType,
  GET_EXPERT_PROFILE,
  GET_ROOT_SITE,
  GET_SITE,
  REDIRECT_TO,
  USER_RESET_PASSWORD,
} from 'constants/redux-actions';

const initState = {};

const redirectToReducer = createReducer(initState, {
  [ActionFailureType(GET_SITE)]: (_, action) => {
    const status = get(action, 'error.response.status');

    if (status === 404) {
      return { status, redirectPath: NOT_FOUND_PATH };
    }
  },
  [ActionFailureType(GET_EXPERT_PROFILE)]: (_, action) => {
    const status = get(action, 'error.response.status');

    if (status === 401) {
      return { status };
    } else if (status === 404) {
      return { status, redirectPath: NOT_FOUND_PATH };
    }

    return initState;
  },
  [ActionFailureType(GET_ROOT_SITE)]: () => ({
    redirectPath: NOT_FOUND_PATH,
  }),
  [ActionClearType(REDIRECT_TO)]: () => initState,
  [ActionSuccessType(USER_RESET_PASSWORD)]: (state, action) =>
    isMfaChallengeResponse(get(action, 'payload.data')) ? initState : { redirectPath: ROOT_PATH },
  [REDIRECT_TO]: (_, action) => ({
    redirectPath: action.payload,
  }),
});

export default redirectToReducer;
